import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import moment from 'moment';

import OverflowH from './OverflowH';
import DotTooltip from './DotTooltip';
import TableHeader from './TableHeader';

const LogsList = ({
  logs = [],
  total = 0,
  loggableId,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Log of {loggableId}</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} reports</p>
        </div>
      </div>

      <div className='Table Table--logs-list'>
        {(() => {
          const columnHeaders = [
            'ID', 'Level', 'Action', 'User ID', 'Message', 'Create at',
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <div
                  key={key}
                  className='Table__col Table__col--th'
                >
                  {header}
                </div>
              ))}
            </div>
          )
        })()}

        {logs.map((log, i) => (
          <div
            className='Table__row'
            key={i}
          >
            <div className='Table__col'>{get(log, 'id')}</div>
            <div className='Table__col'>{get(log, 'level')}</div>
            <div className='Table__col'>{get(log, 'action')}</div>

            <div className='Table__col'>
              <DotTooltip
                user={log.user}
              />
            </div>

            <div className='Table__col'>
              <OverflowH
                text={get(log, 'message')}
              />
            </div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: log.createdAt !== null ?
                    moment(log.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default LogsList;
